<template>
    <div class="my_monitor_box">
        <Row class="table-style-size">
            <i-col span="4">监测样本</i-col>
            <i-col span="4" v-show="tabType == 'image'">关建词</i-col>
            <i-col span="4" v-show="tabType != 'image'">监测名称</i-col>
            <i-col span="4">监测时间</i-col>
            <i-col span="4">监测范围</i-col>
            <i-col span="4">疑似侵权</i-col>
            <i-col span="4">操作</i-col>
        </Row>

        <div v-if="JSON.stringify(data) != '{}' && data.records.length!=0">
            <Row class="table-style-size table-style-body" style="height:90px" v-for="(item,index) in data.records">
                <i-col span="4" class="evdience-table">
                    <img class="workImage" v-if="item.type == 'image' " :src="item.workImage + '?x-image-process=image/resize,m_fixed,w_84,h_60'" alt='版权登记'/>
                    <span v-else class="text_ellipsis">{{ item.type == 'music' ? item.musicName : item.textContent }}</span>
                </i-col>
                <i-col span="4" class="evdience-table">
<!--                    <span class="text_ellipsis">{{ item.monitorName }}</span>-->
                    <Tooltip style="max-width: 100%;" max-width="200" :content="item.monitorName"><p style="width:184px"
                            class="partial_result_url">{{ item.monitorName }}</p></Tooltip>
                </i-col>
                <i-col span="4">{{ item.startTime }}</i-col>
                <!-- <i-col span="4"><span v-for="(item2,index2) in item.scopeStr">{{ index2+1 == item.scopeStr.length ? item2 : item2+'，'  }}</span></i-col> -->
                <i-col span="4">
                    <Tooltip :transfer="true" :content="item.scopeStr.join(',')" placement="bottom"><div style="width:184px;white-space:nowrap;" class="text-overflow-2">{{item.scopeStr.join(',')}} </div></Tooltip>
                </i-col>
                <i-col span="4">{{ item.spreadNumber }}</i-col>
                <i-col span="4">
                    <router-link style="display: inline-block;" class="btn-84" :to="'/monitorDetails?id='+ item.id">详情</router-link>
                </i-col>
            </Row>
            <div class="commont-page" style="position: absolute;bottom: 10px;left: 50%;transform: translate(-50%, -50%);">
                <Page @on-change="changepage" :total="total" size="small" :page-size="pageSize" :current="data.current-0" show-total show-elevator class="page-size-style"></Page>
                <span class="page-total-span">/&nbsp;{{pages}}页</span>
            </div>
        </div>

        <errorTips v-else></errorTips>
    </div>

</template>

<script>
    import errorTips from '@/views/main-components/error-tips';

    export default {
        name: 'myMonitorComponents',
        components:{
            errorTips
        },
        props:{
            tabType: {
                type: String,
                default: ""
            },
            data: {
                type: Object,
                default: {}
            },
            total: {
                type: Number,
                default: 0
            },
            pages: {
                type: Number,
                default: 0
            },
            pageSize: {
                type: Number,
                default: 5
            },
        },
        data() {
            return {
            }
        },

        methods:{
            changepage(value){
                this.$emit("fatherReceivePage",value);


            }
        }
    }
</script>
<style>
    .my_monitor_box{
        min-height: 570px;
        position: relative;
    }
    .text_ellipsis{
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        white-space: nowrap;
        /*display: -webkit-box;*/
        /*word-wrap: break-word;*/
        /*-webkit-line-clamp: 3;*/
        /*-webkit-box-orient: vertical;*/
        padding: 0 10px;
    }
    .workImage{
        object-fit: cover;
    }

    .partial_result_url {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .center-table-list .table-list {
        width: 1108px;
    }
</style>